var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSunFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.483.01h1.549v6.14a5.914 5.914 0 0 1 2.81 1.152l4.342-4.34 1.095 1.094-4.333 4.333a5.915 5.915 0 0 1 1.2 2.847h6.111v1.548h-6.102a5.913 5.913 0 0 1-1.168 2.859l4.307 4.307-1.095 1.095-4.302-4.302a5.914 5.914 0 0 1-2.865 1.194v6.073h-1.55v-6.073a5.915 5.915 0 0 1-2.88-1.206l-4.296 4.296-1.095-1.095 4.304-4.305a5.914 5.914 0 0 1-1.156-2.843H.257v-1.548h6.11a5.915 5.915 0 0 1 1.189-2.83l-4.33-4.33 1.096-1.095 4.333 4.334a5.914 5.914 0 0 1 2.828-1.166V.01Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSunFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SunFilled.f6e8e4b5b3c3449bdbc685c32da02b6c.svg";